import { Outlet } from 'react-router';

import { Flex } from '@chakra-ui/react';

import { useDeepCompareEffect } from '@enterprise/hooks';

import { useApplicationStore } from '@hooks/application/application-store.hook';
import { useGetTooltips } from '@hooks/tooltip/get-tooltips.hook';

const MainContent = () => {
  const setTooltips = useApplicationStore(({ setTooltips }) => {
    return setTooltips;
  });
  const { data: tooltips } = useGetTooltips();

  useDeepCompareEffect(() => {
    setTooltips(tooltips ?? {});
  }, [tooltips, setTooltips]);

  return (
    <Flex
      className="size-full"
      flexDirection="column">
      <Outlet />
    </Flex>
  );
};

export default MainContent;
